import PropTypes from 'prop-types';
import * as React from 'react';
import { connect } from 'react-redux'; 
import { showPrintPreviewModal } from '../../actions/modalActions';
import { IFormMonths, IHistory, IForms } from '../../interfaces';
import { getOIFormSummaryData } from '../../services/oiformService';
import { printDetails } from '../../utils/generalUtils';
import { Async } from '../reusableComponents/Async';
import { BasePage } from '../reusableComponents/BasePage';
import { ErrorPage } from '../reusableComponents/ErrorPage';
import { Loader } from '../reusableComponents/Loader';
import { PrintPreviewModal } from '../reusableComponents/ModalComponents/PrintPreviewModal';
import { OIReportsData } from './OIReportsData';
import { withRouter } from 'react-router-dom'; 

export interface IReportSummaryPageProps {
    environment?: number;
    nearMiss?: number;
    other?: number;
    safety?: number;
    total?: number;
    userId?: string;
    observations?: {
        'Positive Observation': number;
        'Negative Observation': number;
    };
    combinedOthers?: boolean;
    health?: number;
    formMonths?: IFormMonths;
    security?: number;
    /* concernTypes: {
        Safety: number,
        Health: number,
        Environment: number,
        Security: number,
        Other: number
    }; */
    concernTypes?: any;
    activityConcernTypes?: Object;
    formSummaryData: any;
    filterData: {
        year: string;
        month: string;
        filterType: string;
    };
    history?: IHistory;
    forms?: IForms;
} 

export interface IReportSummaryPageState {
    showMonthlyFilter: boolean;
    showYearlyFilter: boolean;
    hideElement: boolean;
}

export class ReportSummaryPageImpl extends React.PureComponent<IReportSummaryPageProps, IReportSummaryPageState> {
    constructor(props: IReportSummaryPageProps | Readonly<IReportSummaryPageProps>) {
        super(props);
        this.state = { showMonthlyFilter: false, showYearlyFilter: false, hideElement: false };
    }

    ref: any;

    getChildContext() {
        return { formModel: 'forms.oiReports' };
    }

    static childContextTypes = {
        formModel: PropTypes.string
    };

    promise = async () => { 
        await getOIFormSummaryData(); 
        return null;
    }

    exportCharts = (val: any) => {
        printDetails(this.ref, 'OIReports');
    }

    renderPrintPreviewModal = () => { 
        showPrintPreviewModal('oi-report'); 
        return;
    }

    renderContent = (showCheckBox: boolean, isAnimationActive: boolean, id?: string) => {
        if(!this.props.formSummaryData)
            return;
        const { observations, nearMiss, activityConcernTypes, total, formMonths, combinedOthers } = this.props.formSummaryData;
        const { filterData, concernTypes } = this.props.formSummaryData;
        const data: {
            name?: string;
            value?: number;
        }[] = [];

        let positiveObservations: any = 0;
        let negativeObservations: any = 0;

        if (observations) {
            positiveObservations = observations['Positive Observation'];
            negativeObservations = observations['Negative Observation'];
        }

        /* for (let key in concernTypes) {
            data.push({ name: key, value: concernTypes[key] });
        } */
       
        if(concernTypes) {
            if ("Safety" in concernTypes) 
                data.push({ name: 'Safety', value: concernTypes['Safety'] });
            if ("Health" in concernTypes) 
                data.push({ name: 'Health', value: concernTypes['Health'] });
            if ("Environment" in concernTypes) 
                data.push({ name: 'Environment', value: concernTypes['Environment'] });
            if ("Security" in concernTypes) 
                data.push({ name: 'Security', value: concernTypes['Security'] });   
            for (let key in concernTypes) {
                if(key!=='Safety' && key!=='Health' && key!=='Environment' && key!=='Security' ) { 
                    data.push({ name: key, value: concernTypes[key] });
                }
            }
        }
        /* const pieChartData = {
            environment, other, safety, total, health, security
        }; */
        const summaryCardsData = { positiveObservations, negativeObservations, total: total || 0 , nearMiss, }; 
        const lineChartData = { formMonths };
        const barChartData = { positiveObservations, negativeObservations, nearMiss };
        return <div> 
            <OIReportsData
                id={id}
                filterData={filterData}
                activityData={activityConcernTypes}
                lineChartData={lineChartData}
                barChartData={barChartData}
                combinedOthers={combinedOthers}
                concernTypes={data}
                summaryCardsData={summaryCardsData}
                showCheckBox={showCheckBox} 
                isAnimationActive={!showCheckBox}
                getRef={value => this.ref = value}
                history={this.props.history}
                forms={this.props.forms}
            />
            <div style={{ padding: '10px', textAlign: 'center' }} className="export-button-container">
                <button className="button" onClick={this.renderPrintPreviewModal}>Export as PDF</button>
            </div>
        </div>;
    }

    render() {
        return (
            <BasePage className="reports-page">
                <PrintPreviewModal
                    id="oi-report"
                    ref="printPreview"
                    className="oi-report-data"
                    fileName="OIReports"
                    onClickYes={this.exportCharts}
                    style={{ boxShadow: 'none' }}
                >
                    {this.renderContent(true, false, 'print')}
                </PrintPreviewModal>
                <Async
                    identifier="OIFormSummary"
                    promise={this.promise}
                    loader={<Loader />}
                    error={<ErrorPage />}
                    content={this.renderContent(false, true)}
                />
            </BasePage >
        );
    }
}

export function mapStateToProps(state: { miscellaneous?: any; formSummary?: any; login?: any; forms?: any }) {
    const { formSummary } = state; 
    /* if (!formSummary.get('oiFormSummary')) {
        return { userId };
    } */
    const formSummaryData = formSummary.get('oiFormSummary'); 
    return {
        /* nearMiss: formSummary.get('oiFormSummary').nearMiss,
        environment: formSummary.get('oiFormSummary').environment,
        formMonths: formSummary.get('oiFormSummary').formMonths,
        observations: formSummary.get('oiFormSummary').observations,
        total: formSummary.get('oiFormSummary').total,
        combinedOthers: formSummary.get('oiFormSummary').combinedOthers,
        concernTypes: formSummary.get('oiFormSummary').concernTypes,
        activityConcernTypes: formSummary.get('oiFormSummary').activityConcernTypes, */
        filterData: state.miscellaneous.get('filterOIReports'),
        formSummaryData, forms: state.forms,
    };
}

export const ReportSummaryPage =
    withRouter(connect<IReportSummaryPageProps, any, any>(mapStateToProps)(ReportSummaryPageImpl));
